import { http } from '@pendo/http';
const groupsApi = '/api/s/_SID_/group';
// Endpoints should be called through VUEX ONLY to ensure the state store is
// up-to-date and that we only call the API when needed.

export function fetchGroups ({ items } = {}) {
    const params = items ? '?items=true' : '';

    return http.get(`${groupsApi}${params}`);
}

export function fetchGroup ({ items, id }) {
    const params = items ? '?items=true' : '';

    return http.get(`${groupsApi}/${id}${params}`);
}

export function deleteGroup ({ id }) {
    return http.delete(`${groupsApi}/${id}`);
}

export function fetchGroupIsEmpty ({ id }) {
    return http.get(`${groupsApi}/${id}/isempty`);
}

export const createGroup = (group) => http.post(groupsApi, group);

export const updateGroup = (group) => http.patch(`${groupsApi}/${group.id}`, group);

export async function addItemToGroup (params) {
    const { groupId, itemType, itemId } = params;
    const response = await http.put(`${groupsApi}/${groupId}/${itemType}/${itemId}`, null);

    return response.data;
}

export async function removeItemFromGroup (params) {
    const { groupId, itemType, itemId } = params;
    const response = await http.delete(`${groupsApi}/${groupId}/${itemType}/${itemId}`);

    return response;
}
